import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ea-charts-legend',
    templateUrl: './ea-charts-legend.component.html',
    styleUrls: ['./ea-charts-legend.component.scss'],
    standalone: false
})
export class EaChartsLegendComponent implements OnInit {
  @Input() options;
  @Input() series: any[];
  @Input() showValues: boolean;
  @Input() isRedirect: boolean = false;
  @Input() redirectTo: string;
  @Input() unity: string = '';
  @HostBinding('class.entrance') @Input() animated: boolean = false;
  @HostBinding('class.placeholder') @Input() placeholder: boolean = false;
  readonly placeholderLines = [0, 1, 2, 3];
  arrToRedirect = {
    assurancevie: 'assets/assuranceVie',
    pme: 'assets/pme',
    tangible: 'assets/tangible',
    crowdfunding: 'assets/crowdfunding',
    scpi: 'estates/scpi',
    'lmp/lmnp': 'estates/lmplmnp',
    locationnue: 'estates/unfurnished',
    résidenceprincipale: 'estates/residence/overview',
    salaire: 'career',
    loyer: 'career',
    per: 'assets/per',
    perp: 'assets/per',
    pea: 'assets/pea',
    peapme: 'assets/pea',
    perco: 'assets/pee',
    pee: 'assets/pee',
    comptetitre: 'assets/comptes-titres',
    livret: 'assets/bank-resources',
    autres: 'global',
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  value(data) {
    return data.trueValue ? data.trueValue : data.value;
  }
}
